<script>
import axios from 'axios'
import Layout from '../../../layouts/auth'
import appConfig from '@/app.config'
import { email, required } from 'vuelidate/lib/validators'
import { EMAIL_TO } from '@/services/api/auth'
import { mapGetters } from 'vuex'
import { Helper } from '@/mixin/helper'
import VueHcaptcha from '@hcaptcha/vue-hcaptcha'
import McInputNumber from '@/components/McInputNumber'

export default {
  page: {
    title: 'Lupa Kata Sandi',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    VueHcaptcha,
    McInputNumber
  },
  mixins: [Helper],
  data() {
    return {
      email: '',
      message: '',
      detectedType: 'email',
      invalidEmail: false,
      siteKey: process.env.VUE_APP_HCAPTCHA_SITEKEY,
      isCaptchaVerified: false,
      hcaptcha_token_response: null,
      captchaError: false,
    }
  },
  validations: {
    email: {
      required,
    },
  },
  computed: {
    ...mapGetters({
      getAsset: 'asset/getAsset',
    }),
  },
  mounted() {
    this.adjustImageSize()
  },
  methods: {
    async submitEmail() {
      const ipFetch = await axios.get('https://api.ipify.org?format=json')
      const remoteIp = ipFetch.data.ip

      if (!this.isCaptchaVerified) {
        this.captchaError = true
        return
      }
      this.captchaError = false
      this.$v.email.$touch()
      if (this.$v.email.$invalid) return
      const input = {
        email: this.email,
        hcaptcha_token_response: this.hcaptcha_token_response,
        remoteip: remoteIp,
      }
      this.$apollo
        .mutate({
          mutation: EMAIL_TO,
          variables: {
            input: input,
          },
        })
        .then((response) => {
          if (response.data.emailForgotPassword.isSuccessful == false) {
            this.$mcToast.error(response.data.emailForgotPassword.message)
          } else if (
            response.data.emailForgotPassword.emailForgotPassword.message == 'failed to get email'
          ) {
            this.invalidEmail = true
            setTimeout(() => {
              this.invalidEmail = false
            }, 5000)
          } else {
            localStorage.setItem('emailOTP', this.email)
            this.$store.commit('resetPassword/SET_EMAIL', this.email)
            this.$router.push({ name: 'OTP Verification' })
          }
        })
    },
    resetCaptcha() {
      this.isCaptchaVerified = false
      this.hcaptcha_token_response = null
      // Reset the captcha using the component's reset method
      this.$refs.captcha.reset()
    },
    backToLogin() {
      // SWAT-77: Prevent using old mechanism
      window.location = '/login'
    },
    onVerify(token) {
      this.isCaptchaVerified = true
      this.hcaptcha_token_response = token
    },
    onExpire() {
      // Handle captcha expiration
      this.resetCaptcha()
    },
    onChallengeExpire() {
      // Handle challenge expiration
      this.resetCaptcha()
    },
    onError(err) {
      // Handle captcha error
      this.resetCaptcha()
    },
    adjustImageSize() {
      this.resizeImage(this.$refs.imgPrimaryLogo, 45, 150)
      this.resizeImage(this.$refs.imgCopyrightLogo, 15, 50)
    },
    handleChangeNumber(val) {
      this.email = val
      this.handleDynamicInput(val)
    },
    detectInputType(value) {
      if (!value || !value.trim()) {
        return 'text'
      }

      if (value.includes('@') || (value.includes('.') && value.length > 3)) {
        return 'email'
      }

      const phonePattern = /^[+]?[\d\s\-()]+$/
      const hasNumbers = /\d/.test(value)
      const startsWithPlus = value.startsWith('+')

      if (hasNumbers && (phonePattern.test(value) || startsWithPlus)) {
        return 'phone'
      }

      return 'text'
    },
    handleDynamicInput(value) {
      const oldType = this.detectedType
      this.detectedType = this.detectInputType(value)

      if (oldType !== this.detectedType) {
        this.$nextTick(() => {
          if (this.detectedType === 'text' && this.$refs.emailInput) {
            this.$refs.emailInput.focus(); 
          }
        });
      }
    },
  },
}
</script>
<template>
  <Layout>
    <div class="mc-auth__form">
      <h1 class="mc-auth__logo mb-0 pt-5">
        <router-link to="/">
          <img :src="getAsset('primaryLogo', 'login')" alt ref="imgPrimaryLogo" />
        </router-link>
      </h1>
      <div class="mc-auth__form-wrapper mc-auth__form-wrapper--forgot">
        <h4 class="mc-auth__label">{{ $t('forgotPassword.label.forgot') }}</h4>
        <p>
          {{ $t('forgotPassword.text.enterEmail') }}
        </p>
        <b-form @submit.prevent="submitEmail">
          <b-form-group class="mb-3" id="input-group-1" label-for="input-1">
            <mc-input-number
              v-if="detectedType === 'phone'"
              id="phone_number"
              v-model="email"
              name="phoneNo"
              :onFocus="true"
              :invalidMsg="$t('master.form.employee.phoneFormat')"
              :placeholder="$t('master.form.employee.phoneNumber')"
              @onChange="(val) => this.handleChangeNumber(val)"
            />
            <b-form-input
              v-else
              id="input-1"
              ref="emailInput"
              v-model="email"
              type="text"
              placeholder="Email / Number"
              :class="{
                'is-invalid': $v.email.$error,
              }"
              @input="handleDynamicInput"
            >
            </b-form-input>
            <div v-if="$v.email.$error || invalidEmail" class="invalid-feedback">
              <span v-if="invalidEmail">{{ $t('login.text.emailNotRegistered') }} </span>
              <span v-if="!$v.email.required">{{ $t('login.text.emailEmpty') }}</span>
              <span v-if="!$v.email.email">{{ $t('login.text.invalidEmailFormat') }}</span>
            </div>
          </b-form-group>
          <div class="mt-3">
            <vue-hcaptcha
              ref="captcha"
              :sitekey="siteKey"
              @verify="onVerify"
              @expired="onExpire"
              @challenge-expired="onChallengeExpire"
              @error="onError"
              language="id"
            />
          </div>
          <div v-if="captchaError" class="text-danger">
            <span>{{ $t('forgotPassword.text.captchaNotValid') }}</span>
          </div>
          <div class="mt-5">
            <b-button
              :disabled="!isCaptchaVerified || !email"
              type="submit"
              variant="primary"
              class="w-100"
            >
              {{ $t('forgotPassword.action.next') }}
            </b-button>
            <a class="text-primary d-block mt-3" @click="backToLogin()">
              {{ $t('forgotPassword.action.back') }}
            </a>
          </div>
        </b-form>
      </div>
      <div class="mc-auth__copyright">
        <span
          :hidden="
            getAsset('copyrightLogo', 'general') == null ||
            getAsset('copyrightLogo', 'general') == ''
          "
          >{{ $t('login.text.presented') }}
          <img :src="getAsset('copyrightLogo', 'general')" class="ms-2" alt ref="imgCopyrightLogo"
        /></span>
      </div>
    </div>
  </Layout>
</template>
